import styled from "styled-components";
import heroExecutiveSearch from "../../assets/hero/executive-search.png";
import { palette, fonts, radii } from "../../styles/palette";

export const NotFoundContainer = styled.div`
  position: relative;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${palette.navy};
  padding: 20px;
  overflow: hidden;

  /* Marca de agua de marca (hero LaPieza). */
  &::before {
    content: "";
    position: absolute;
    left: -70px;
    bottom: -70px;
    width: min(45vw, 380px);
    height: min(45vw, 380px);
    background: url(${heroExecutiveSearch}) no-repeat center / contain;
    opacity: 0.22;
    pointer-events: none;
  }
`;

export const NotFoundContent = styled.div`
  position: relative;
  text-align: center;
  max-width: 500px;
  padding: 48px 40px;
  background: ${palette.white};
  border: 1px solid ${palette.border};
  border-radius: ${radii.md};
  box-shadow: 0 18px 48px rgba(35, 35, 35, 0.24);
`;

export const NotFoundIcon = styled.div`
  margin-bottom: 24px;
  color: ${palette.red};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const NotFoundTitle = styled.h1`
  font-family: ${fonts.heading};
  font-size: 72px;
  font-weight: 700;
  color: ${palette.navy};
  margin: 0 0 16px 0;
  line-height: 1;
`;

export const NotFoundSubtitle = styled.h2`
  font-family: ${fonts.heading};
  font-size: 28px;
  font-weight: 600;
  color: ${palette.black};
  margin: 0 0 16px 0;
`;

export const NotFoundDescription = styled.p`
  font-size: 16px;
  color: ${palette.textSecondary};
  margin: 0 0 32px 0;
  line-height: 1.6;
`;

export const NotFoundButton = styled.button`
  background: ${palette.red};
  color: ${palette.white};
  border: none;
  border-radius: ${radii.pill};
  padding: 14px 32px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 14px ${palette.redGlow};

  &:hover {
    background: ${palette.redHover};
    transform: translateY(-2px);
    box-shadow: 0 6px 18px ${palette.redGlow};
  }

  &:active {
    transform: translateY(0);
  }
`;
